module.exports = __webpack_public_path__ + "img/multiplier.5c245845.png";